<template>
  <Header>
    <div class="mobile-header">
      <div class="mobile-header_">
        <router-link to="/home" class="mobile-header-logo">
          <div v-if="logo.length>0" :style="'backgroundImage:url(' + domainNameH5 + '/' + logo[0].picurl + ')'"></div>
        </router-link>
        <div class="mobile-navbtn" :class="[ navOpen ? 'active' : '' ]">
          <div class="mobile-navbtn_" @click="clickNavBth"></div>
        </div>
        <div class="mobile-memberbtn" :class="[ memberNavOpen ? 'active' : '' ]">
          <div class="mobile-memberbtn_" @click="clickMemberBth"></div>
        </div>

        <div class="mobile-member-main">
          <div class="mobile-member-main_">
            <div class="mobile-member-head">
              <div class="mobile-member-img"><div></div></div>
              <div class="mobile-member-name">{{getUser}}</div>
            </div>
            <div class="mobile-member-nav">
              <div class="mobile-member-li" :class="[ getActiveSendMenu == 'member' ? 'active' : '' ]" @click="hideMemberNav">
                <router-link to="/member/index">
                  <div class="chname">基本信息</div>
                  <div class="enname">Basic Information</div>
                </router-link>
              </div>
              <div class="mobile-member-li" :class="[ getActiveSendMenu == 'security' ? 'active' : '' ]" @click="hideMemberNav">
                <router-link to="/member/security">
                  <div class="chname">个人安全信息</div>
                  <div class="enname">Personal Safety Information</div>
                </router-link>
              </div>
              <div class="mobile-member-li" :class="[ getActiveSendMenu == 'reserve' ? 'active' : '' ]" @click="hideMemberNav">
                <router-link to="/member/reserve">
                  <div class="chname">预约信息</div>
                  <div class="enname">Reservation information</div>
                </router-link>
              </div>
              <div class="mobile-member-li" :class="[ getActiveSendMenu == 'family' ? 'active' : '' ]" @click="hideMemberNav">
                <router-link to="/member/family">
                  <div class="chname">我的家庭</div>
                  <div class="enname">My Family</div>
                </router-link>
              </div>
              <div class="mobile-member-loginout">
                <div @click="loginOut">退出登录</div>
              </div>
            </div>
          </div>
        </div>

        <div class="mobile-navmain">
          <div class="mobile-navmain_">
            <div class="mobile-navmain-list" v-if="nav.length>0">
              <ul class="ul">
                <li class="top_nav_lia" @click="hideNav" :class="[ getActiveMenu == 'home' ? 'active' : '' ]">
                  <router-link class="li-a" to="/home">
                    <div class="chname">首页</div>
                    <div class="enname">Home</div>
                  </router-link>
                </li>
                <li class="top_nav_lia" :class="[ getActiveMenu == 'homecare' ? 'active' : '' ]">
                  <div class="li-a" @click="showSecondNav(2)">
                    <div class="chname">{{nav[0]['classname']}}</div>
                    <div class="enname">{{nav[0]['classname_en']}}</div>
                    <span></span>
                  </div>
                </li>
                <li class="top_nav_lia" :class="[ getActiveMenu == 'mechanism' ? 'active' : '' ]">
                  <div class="li-a" @click="showSecondNav(3)">
                    <div class="chname">{{nav[1]['classname']}}</div>
                    <div class="enname">{{nav[1]['classname_en']}}</div>
                    <span></span>
                  </div>
                </li>
                <li class="top_nav_lia" @click="hideNav">
                  <router-link class="li-a" to="/publicwelfare">
                    <div class="chname">{{nav[7]['classname']}}</div>
                    <div class="enname">{{nav[7]['classname_en']}}</div>
                  </router-link>
                </li>
                <li class="top_nav_lia" :class="[ getActiveMenu == 'about' ? 'active' : '' ]">
                  <div class="li-a" @click="showSecondNav(4)">
                    <div class="chname">{{nav[2]['classname']}}</div>
                    <div class="enname">{{nav[2]['classname_en']}}</div>
                    <span></span>
                  </div>
                </li>
                <li class="top_nav_lia" :class="[ getActiveMenu == 'join' ? 'active' : '' ]">
                  <div class="li-a" @click="showSecondNav(5)">
                    <div class="chname">{{nav[3]['classname']}}</div>
                    <div class="enname">{{nav[3]['classname_en']}}</div>
                    <span></span>
                  </div>
                </li>
              </ul>
              <ul class='top_ul1' id='top_ul2'>
                <li>
                  <div class='top_li_title' @click="backFirstNav(2)">
                    <div class="chname">{{nav[0]['classname']}}</div>
                    <div class="enname">{{nav[0]['classname_en']}}</div>
                    <span></span>
                  </div>
                </li>
                <li v-for="item in homeCare" :key="item.id" @click="hideNav">
                  <router-link
                    class='top_ul1_lia'
                    :class="[ getActiveSendMenu == item.id ? 'active' : '' ]"
                    :to="{ path: '/homecare/index', query: { cid: item.id } }"
                  >
                    <div class="chname">{{item.classname}}</div>
                    <div class="enname">{{item.classname_en}}</div>
                  </router-link>
                </li>
              </ul>
              <ul class='top_ul1' id='top_ul3'>
                <li>
                  <div class='top_li_title' @click="backFirstNav(3)">
                    <div class="chname">{{nav[1]['classname']}}</div>
                    <div class="enname">{{nav[1]['classname_en']}}</div>
                    <span></span>
                  </div>
                </li>
                <li v-for="item in mechanism" :key="item.id" @click="hideNav">
                  <router-link
                    class='top_ul1_lia'
                    :class="[ getActiveSendMenu == item.id ? 'active' : '' ]"
                    :to="{ path: '/mechanism/index', query: { cid: item.id } }"
                  >
                    <div class="chname">{{item.classname}}</div>
                    <div class="enname">{{item.classname_en}}</div>
                  </router-link>
                </li>
              </ul>
              <ul class='top_ul1' id='top_ul4'>
                <li>
                  <div class='top_li_title' @click="backFirstNav(4)">
                    <div class="chname">{{nav[2]['classname']}}</div>
                    <div class="enname">{{nav[2]['classname_en']}}</div>
                    <span></span>
                  </div>
                </li>
                <li v-for="item in aboutus" :key="item.id" @click="hideNav">
                  <router-link
                    class='top_ul1_lia'
                    :class="[ getActiveSendMenu == item.id ? 'active' : '' ]"
                    :to="{ path: '/about', query: { cid: item.id } }"
                  >
                    <div class="chname">{{item.classname}}</div>
                    <div class="enname">{{item.classname_en}}</div>
                  </router-link>
                </li>
                <li @click="hideNav">
                  <router-link to="/publicwelfare" class='top_ul1_lia' :class="[ getActiveSendMenu == 'publicwelfare' ? 'active' : '' ]">
                    <div class="chname">{{nav[7]['classname']}}</div>
                    <div class="enname">{{nav[7]['classname_en']}}</div>
                  </router-link>
                </li>
                <li @click="hideNav">
                  <router-link to="/seniorclass" class='top_ul1_lia' :class="[ getActiveSendMenu == 'seniorclass' ? 'active' : '' ]">
                    <div class="chname">{{nav[8]['classname']}}</div>
                    <div class="enname">{{nav[8]['classname_en']}}</div>
                  </router-link>
                </li>
              </ul>
              <ul class='top_ul1' id='top_ul5'>
                <li>
                  <div class='top_li_title' @click="backFirstNav(5)">
                    <div class="chname">{{nav[3]['classname']}}</div>
                    <div class="enname">{{nav[3]['classname_en']}}</div>
                    <span></span>
                  </div>
                </li>
                <li @click="hideNav">
                  <router-link to="/join/volunteer" class='top_ul1_lia' :class="[ getActiveSendMenu == 'volunteer' ? 'active' : '' ]">
                    <div class="chname">{{joinus[0]['classname']}}</div>
                    <div class="enname">{{joinus[0]['classname_en']}}</div>
                  </router-link>
                </li>
                <li @click="hideNav">
                  <router-link to="/join/goldenyears" class='top_ul1_lia' :class="[ getActiveSendMenu == 'goldenyears' ? 'active' : '' ]">
                    <div class="chname">{{joinus[1]['classname']}}</div>
                    <div class="enname">{{joinus[1]['classname_en']}}</div>
                  </router-link>
                </li>
                <li @click="hideNav">
                  <router-link to="/join/socialservice" class='top_ul1_lia' :class="[ getActiveSendMenu == 'socialservice' ? 'active' : '' ]">
                    <div class="chname">{{joinus[2]['classname']}}</div>
                    <div class="enname">{{joinus[2]['classname_en']}}</div>
                  </router-link>
                </li>
              </ul>
            </div>
            <div class="mobile-navmain-bottom">
              <div class="mobile-ewm">
                <div class="mobile-ewm-li" v-for="(item, index) in ewimg" :key="index">
                  <div :style="'backgroundImage:url('+ domainNameH5+'/'+item.picurl +')'"></div>
                </div>
              </div>
              <div class="mobile-ewm-words">金色年华官方微信</div>
              <a href="http://www.zju-goldenyears.xyz:8080/Admin" target="_blank" class="mobile-linkbtn">金色智云</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Header>
</template>

<script>
import { mapGetters } from 'vuex'
import { getHeaderNavData, getLogoData } from '../../api/getData'
export default {
  name: 'MobileHeader',
  props: {
    ewimg: Array
  },
  data () {
    return {
      navOpen: false,
      memberNavOpen: false,
      logo: [],
      nav: [],
      homeCare: {},
      mechanism: {},
      aboutus: {},
      joinus: {}
    }
  },
  computed: {
    ...mapGetters([
      'getUserId',
      'getUser',
      'getActiveMenu',
      'getActiveSendMenu'
    ])
  },
  created () {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      let result = await getHeaderNavData()
      this.nav = result.nav
      this.homeCare = result.home_care
      this.mechanism = result.mechanism
      this.aboutus = result.aboutus
      this.joinus = result.joinus

      let postdata = { id: 2 }
      let logoResult = await getLogoData(postdata)
      this.logo = logoResult.logo
    },
    clickNavBth () {
      this.navOpen = !this.navOpen
      window.$('.mobile-navmain').stop().fadeToggle(500)
      this.memberNavOpen = false
      window.$('.mobile-member-main').stop().fadeOut(500)
    },
    showSecondNav (num) {
      $('.mobile-navmain-list').height($('#top_ul' + num).height())
      $('#top_ul' + num).stop().animate({ 'left': '0px' })
      $('.mobile-navmain-list .ul').stop().fadeOut(100)
    },
    backFirstNav (num) {
      $('.mobile-navmain-list').height($('.mobile-navmain-list .ul').height())
      $('.mobile-navmain-list .ul').stop().fadeIn(100)
      $('#top_ul' + num).stop().animate({ 'left': '100%' })
    },
    hideNav () {
      this.navOpen = false
      window.$('.mobile-navmain').stop().fadeOut(500)
    },
    clickMemberBth () {
      if (this.getUserId === '') {
        this.$router.push({ path: '/login' })
        return false
      }
      this.memberNavOpen = !this.memberNavOpen
      window.$('.mobile-member-main').stop().fadeToggle(500)
      this.navOpen = false
      window.$('.mobile-navmain').stop().fadeOut(500)
    },
    hideMemberNav () {
      this.memberNavOpen = false
      window.$('.mobile-member-main').stop().fadeOut(500)
    },
    loginOut () {
      let path = this.$route.path
      let pathArr = path.split('/')
      this.$store.dispatch('LogOut').then(() => {
        window.$('.mobile-member-main').stop().fadeOut(500)
        if (pathArr[1] === 'member' || pathArr[1] === 'attention') {
          this.$router.push({
            path: '/'
          })
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped lang="less">
  .mobile-header_{
    position: relative;
    height: 50px;
    padding: 0 2.5px 0 0;
    .mobile-header-logo{
      float: left;
      width: 68px;
      height: 50px;
      padding: 6px 15px;
      div{
        width: 38px;
        height: 38px;
        background-repeat: no-repeat;
        background-size: 38px auto;
        background-position: center;
      }
    }
    .mobile-navbtn{
      float: right;
      width: 50px;
      height: 50px;
      transition: all 0.5s ease 0s;
      .mobile-navbtn_{
        width: 100%;
        height: 100%;
        background-image: url("../../assets/images/nav.png");
        background-repeat: no-repeat;
        background-size: 25px auto;
        background-position: center;
      }
      &.active{
        background-color: #ff7a3d;
        .mobile-navbtn_{
          background-image: url("../../assets/images/close.png");
          background-size: 19px auto;
        }
      }
    }
    .mobile-memberbtn{
      .mobile-navbtn;
      .mobile-memberbtn_{
        .mobile-navbtn_;
        background-image: url("../../assets/images/mobile-memberbtn.png");
        background-size: 18px auto;
        &.active{
          background-color: #ff7a3d;
        }
      }
    }
    .mobile-member-main{
      display: none;
      position: fixed;
      top: 50px;
      bottom: 0;
      left: 0;
      width: 100%;
      background-color: rgba(38,28,36,0.9);
      .mobile-member-head{
        padding: 32px 0 32px;
        background-color: #ff7a3d;
        .mobile-member-img{
          width: 57px;
          height: 57px;
          border-radius: 50%;
          border: 1px solid #ffffff;
          margin: 0 auto;
          padding: 3px;
          div{
            width: 100%;
            height: 100%;
            border-radius: 50%;
            background-color: #f5f4fa;
            background-image: url("../../assets/images/icons.png");
            background-repeat: no-repeat;
            background-size: 292px auto;
            background-position: -217px -273px;
          }
        }
        .mobile-member-name{
          margin-top: 14px;
          font-size: 15px;
          line-height: 15px;
          text-align: center;
          color: #ffffff;
        }
      }
      .mobile-member-nav{
        background-color: #f2f8f8;
        .mobile-member-li{
          border-bottom: 1px solid #ffffff;
          a{
            display: block;
            padding: 9px 28px;
            color: #666467;
            .chname{
              font-size: 15px;
              line-height: 28px;
            }
            .enname{
              font-size: 10px;
              line-height: 10px;
            }
          }
          &.active a{
            color: #eb6420;
          }
        }
        .mobile-member-loginout{
          padding: 50px 0 40px;
          div{
            width: 200px;
            height: 30px;
            margin: 0 auto;
            border-radius: 13px;
            background-color: #ec6420;
            font-size: 14px;
            line-height: 30px;
            text-align: center;
            color: #ffffff;
          }
        }
      }
    }
    .mobile-navmain{
      display: none;
      position: fixed;
      top: 50px;
      bottom: 0;
      left: 0;
      width: 100%;
      background-color: rgba(38,28,36,0.9);
      overflow-y: scroll;
      &::-webkit-scrollbar{
        display: none;
      }
      .mobile-navmain-list{
        position: relative;
        background-color: #f7f7f7;
        .ul{
          .top_nav_lia{
            .li-a{
              position: relative;
              display: block;
              padding: 9px 15px;
              border-bottom: 1px solid #ffffff;
              color: #4b7bbe;
              .chname{
                font-size: 16px;
                line-height: 28px;
              }
              .enname{
                font-size: 10px;
                line-height: 10px;
              }
              span{
                position: absolute;
                right: 15px;
                top: 50%;
                width: 5px;
                height: 12px;
                margin-top: -6px;
                background-image: url("../../assets/images/mobile-arrow.png");
                background-position: center;
                background-repeat: no-repeat;
                background-size: 5px 12px;
              }
            }
            &.active{
              .li-a{
                background-color: #ff7a3d;
                color: #ffffff;
                span{
                  background-image: url("../../assets/images/mobile-arrow-3.png");
                  background-position: center;
                  background-repeat: no-repeat;
                  background-size: 5px 12px;
                }
              }
            }
          }
        }
        .top_ul1{
          position: absolute;
          top:0;
          left:100%;
          width: 100%;
          background-color: #f7f7f7;
          .top_li_title{
            position: relative;
            padding: 9px 15px;
            border-bottom: 1px solid #ffffff;
            color: #4b7bbe;
            .chname{
              font-size: 16px;
              line-height: 28px;
            }
            .enname{
              font-size: 10px;
              line-height: 10px;
            }
            span{
              position: absolute;
              right: 15px;
              top: 50%;
              width: 5px;
              height: 12px;
              margin-top: -6px;
              background-image: url("../../assets/images/mobile-arrow-2.png");
              background-position: center;
              background-repeat: no-repeat;
              background-size: 5px 12px;
            }
          }
          .top_ul1_lia{
            display: block;
            padding: 9px 15px;
            border-bottom: 1px solid #ffffff;
            color: #4b7bbe;
            .chname{
              font-size: 16px;
              line-height: 28px;
            }
            .enname{
              font-size: 10px;
              line-height: 10px;
            }
            &.active{
              color: #ff7a3d;
            }
          }
        }
      }
      .mobile-navmain-bottom{
        padding: 40px 15px 50px;
        background-color: #e66120;
        .mobile-ewm{
          padding: 0 5px;
          overflow: hidden;
          .mobile-ewm-li{
            float: left;
            width: 50%;
            div{
              width: 90px;
              height: 90px;
              margin: 0 auto;
              background-repeat: no-repeat;
              background-position: center;
              background-size: cover;
            }
          }
        }
        .mobile-ewm-words{
          margin-top: 20px;
          font-size: 14px;
          line-height: 14px;
          text-align: center;
          color: #fefefe;
        }
        .mobile-linkbtn{
          display: block;
          width: 200px;
          height: 30px;
          margin: 36px auto 0;
          border-radius: 15px;
          background-color: #ffffff;
          font-size: 14px;
          line-height: 30px;
          text-align: center;
          color: #ec6420;
        }
      }
    }
  }
</style>
